import React from "react";
import { Card, Box, Divider } from "@bca/ui-library";
import styled from "styled-components";
import { layout, LayoutProps, flexbox, FlexboxProps } from "styled-system";

import BidNowContent from "./BidNowContent";
import BuyNowContent from "./BuyNowContent";

interface StyledProps extends LayoutProps, FlexboxProps {}
interface BidNowBuyNowCardProps {
  buyNowAmount: number;
  bidAmount: number;
  reserveMet: boolean;
  increment: number;
  currentBid: number;
  bidHistory: any;
  startingBidAmount: number;
  myMaxProxy: number;
  userBidStatus: string;
  nextPossibleBid: number;
  openBidNowModal: () => void;
  openBuyNowModal: () => void;
  setBidAmount: (value: number) => void;
  getBiddingInfo: () => void;
  setInfo: (value: any) => void;
}

const CardContainer = styled(Card)<StyledProps>`
  ${layout}
  ${flexbox}
`;

const BidNowBuyNowCard: React.FunctionComponent<BidNowBuyNowCardProps> = ({
  buyNowAmount,
  openBuyNowModal,
  ...rest
}) => {
  return (
    <Box
      width={{ mobile: "100%", tablet: "100%", desktop: "50%" }}
      css={`
        @media screen and (min-width: 769px) and (max-width: 1300px) {
          width: 70%;
        }
      `}
    >
      <CardContainer
        width="100%"
        height="auto"
        paddingX={0}
        paddingY={0}
        marginX={0}
        marginY={[3, 7, 0]}
      >
        <Box
          display="flex"
          width="100%"
          height="100%"
          flexDirection={{ mobile: "column", tablet: "column", desktop: "row" }}
          justifyContent="space-between"
          css={`
            @media screen and (min-width: 769px) and (max-width: 1024px) {
              flex-direction: column;
            }
          `}
        >
          <Box m={28}>
            <BuyNowContent
              buyNowAmount={buyNowAmount}
              onBuy={openBuyNowModal}
              layout="BidNowBuyNow"
            />
          </Box>
          <Divider
            display={["none", "none", "block", "block"]}
            orientation="vertical"
            width="1px"
            marginBottom={0}
            marginTop={0}
            marginLeft={0}
            marginRight={0}
          />
          <Divider
            display={["block", "block", "none", "none"]}
            orientation="horizontal"
            width="100%"
            marginBottom={0}
            marginTop={0}
            marginLeft={0}
            marginRight={0}
            css={`
              @media screen and (min-width: 769px) and (max-width: 1075px) {
                display: block;
              }
            `}
          />
          <Box m={28}>
            <BidNowContent {...rest} />
          </Box>
        </Box>
      </CardContainer>
    </Box>
  );
};

export default BidNowBuyNowCard;
